<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/10/2021
  -->

<template>
	<qw-button
		v-bind="$attrs"
		type="circle"
		:tooltip="tooltip"
		:icon="icon"
		:iconImage="iconImage"
		:circleSize="circleSize"
		:iconImageWidth="iconImageWidth"/>
</template>

<script>

import QwBaseButton from "@/core/components/Controls/Buttons/QwBaseButton.vue";

export default {
	name: "QwButtonIcon",
	extends: QwBaseButton,

	inheritAttrs: true,

	props: {
		icon: String,
		iconImage: String,
		iconImageWidth: String,
		circleSize: String,
		tooltip: String,
	},
}
</script>

<style lang="scss">

</style>
